<template lang="pug">
  ul.nav
    li.nav__item
      router-link.nav__link(
      to="/pages/camps/"
      active-class="nav__link_active"
      v-hidden="userData"
      ) {{ translation.header.camps }}
    //li.nav__item
    //  router-link.nav__link(
    //  to="/pages/shifts/"
    //  active-class="nav__link_active"
    //  v-hidden="userData"
    //  ) {{ translation.header.shifts }}
    li.nav__item
      router-link.nav__link(
      to="/pages/about-us/"
      active-class="nav__link_active"
      v-hidden="userData"
      ) {{ translation.header.about }}
    li.nav__item
      router-link.nav__link(
      to="/pages/contacts/"
      active-class="nav__link_active"
      v-hidden="userData"
      ) {{ translation.header.contacts }}
    li.nav__item(
    v-if="!userData"
    )
      a.nav__link(
      href="#"
      id="show-modal"
      @click.prevent="$emit('setShowAuthModal')"
      ) {{ translation.header.log_in }}
    li.nav__item.nav__item_user(
    v-if="userData"
    )
      a.nav__link(
      href="#"
      @click.prevent="onClickUser($event)"
      )
        | {{ userData.first_name.length !== 0 && userData.last_name.length !== 0 ? userData.last_name + ' ' + (userData.first_name ? userData.first_name[0] + "." : "") : userData.email }}
      user-dropdown(
      v-if="showUserDropdown"
      @close="closeDropdown"
      )
</template>

<script>
import {mapState} from "vuex";
import UserDropdown from "./UserDropdown";

export default {
  name: "MainNav",
  components: {UserDropdown},
  computed: {
    ...mapState(["translation"])
  },
  props: ["userData"],
  data() {
    return {
      showUserDropdown: false
    };
  },
  methods: {
    onClickUser(e, type) {
      if (this.showList) {
        this.toggleDropdown();
        return;
      }
      const _e = e;
      if (!type) {
        setTimeout(() => {
          this.onClickUser(_e, "second");
        }, 0);
      } else {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown();
      }
    },
    toggleDropdown() {
      this.showUserDropdown = !this.showUserDropdown;
    },
    closeDropdown() {
      this.showUserDropdown = false;
    }
  }
};
</script>
